import { Validators } from '@lemoncode/fonk';
// import { isTrue } from '@lemoncode/fonk-is-true-validator';
Validators.required.setErrorMessage("This field is required");
// isTrue.setErrorMessage("This field is required");

// Validation on virtual_denominations only when use_virtual_inventory is truthy
export const virtualDenominationsRequired = args => {
    const { value, values } = args;
    if (!values?.use_virtual_inventory) {
        return {
            succeeded: true,
            type: 'virtual_denominations_required',
            message: ''
        }
    }
    return Validators.required.validator(args);
}

// Validation on virtual_discount only when use_virtual_inventory is truthy
export const virtualDiscountRequired = args => {
    const { value, values } = args;
    if (!values?.use_virtual_inventory) {
        return {
            succeeded: true,
            type: 'virtual_discount_required',
            message: ''
        }
    }
    return Validators.required.validator(args);
}

// Validation on visa_premium_fee only when physical_card_option is truthy
export const visaPremiumFeeRequired = args => {
    const { value, values } = args;
    if (!values?.physical_card_option) {
        return {
            succeeded: true,
            type: 'visa_premium_fee_required',
            message: ''
        }
    }
    return Validators.required.validator(args);
}

const validationSchema = {
    field: {
        name: [Validators.required.validator],
        merchant_code: [Validators.required.validator],
        //website: [Validators.required.validator],
        description: [Validators.required.validator],
        redemption_instruction: [Validators.required.validator],
        // // toa_id: [Validators.required.validator],
        // // is_default: [Validators.required.validator, isTrue.validator],
        logo: [Validators.required.validator],
        icon: [Validators.required.validator],
        // conditional virtual inventory fields
        virtual_denominations: [virtualDenominationsRequired],
        virtual_discount: [virtualDiscountRequired],
        // conditional physical card fields
        visa_premium_fee: [visaPremiumFeeRequired],
    }
}
export default validationSchema;